import { WhmCard, WhmCardContent, whmTheme } from "@securitize/reactjs-whm";
import FundHoldingsTable from "../../components/FundHoldingsTable";

export type FundHoldingDetailsProps = { tokenId: string };

const FundHoldingDetails = ({ tokenId }: FundHoldingDetailsProps) => {
  return (
    <WhmCard
      elevation={0}
      sx={{
        width: "100%",
        overflow: "hidden",
        mb: "100px", // A gap for the global sec id fe Helper component
      }}
    >
      <WhmCardContent
        sx={{
          padding: { xs: "0", lg: "0 16px 16px" },
          backgroundColor: {
            xs: whmTheme.palette.background.default,
            sm: whmTheme.palette.background.default,
            md: whmTheme.palette.background.default,
            lg: whmTheme.palette.background.default,
            xl: "unset",
          },
        }}
      >
        <FundHoldingsTable tokenId={tokenId} />
      </WhmCardContent>
    </WhmCard>
  );
};
export default FundHoldingDetails;
